import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";

const MODULE_COLORS = {
  stock_management: "#5A9559",
  qr_serial: "#F57C00",
  dealers: "#388E3C",
  campaigns: "#7B1FA2",
  reports: "#9E9E9E",
  account_billing: "#D32F2F",
  other: "#1976D2",
};

const MODULE_LABELS = {
  stock_management: "Stock Management",
  qr_serial: "QR / Verification",
  dealers: "Dealer Management",
  campaigns: "Campaigns & Loyalty",
  reports: "Reports & Analytics",
  account_billing: "Account & Settings",
  other: "Other",
};

const ModuleBreakdown = ({ data }) => {
  if (!data || !data.modules) return null;

  const maxCount = Math.max(...data.modules.map((m) => m.count), 1);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 500, color: "#172b4d", mb: 2 }}>
        Tickets by Module
      </Typography>
      <Box sx={{ padding: "8px 0" }}>
        {data.modules.map((mod) => (
          <Box
            key={mod.module}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              mb: 1.5,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                color: "#6b778c",
                width: 140,
                textAlign: "right",
                flexShrink: 0,
              }}
            >
              {MODULE_LABELS[mod.module] || mod.module}
            </Typography>
            <Box
              sx={{
                flex: 1,
                height: 24,
                backgroundColor: "#f4f6f8",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: `${(mod.count / maxCount) * 100}%`,
                  backgroundColor: MODULE_COLORS[mod.module] || "#5A9559",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  pl: 1,
                  fontSize: 11,
                  color: "#fff",
                  fontWeight: 500,
                  minWidth: 30,
                }}
              >
                {mod.count}
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

ModuleBreakdown.propTypes = {
  data: PropTypes.object,
};

export default ModuleBreakdown;
